module.exports = __webpack_public_path__ + "assets/img/头条号.7a52d17c.jpg";